<template>
    <div>
        <v-row align="center" no-gutters>
            <v-col :class="[{'grow': $vuetify.breakpoint.smAndUp},
                            {'grow px-3': $vuetify.breakpoint.xsOnly}]">
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                              label="Suchen"
                              dense light class="white"
                              :solo="$vuetify.breakpoint.smAndUp"
                              :flat="$vuetify.breakpoint.smAndUp"
                              :filled="$vuetify.breakpoint.xsOnly"
                              single-line hide-details clearable>
                </v-text-field>
            </v-col>
            <v-col :class="[{'shrink text-no-wrap ml-3': $vuetify.breakpoint.smAndUp},
                            {'shrink text-no-wrap pr-3': $vuetify.breakpoint.xsOnly}]" >
                <v-checkbox v-model="showDeleted" label="inkl. Gelöschte">
                </v-checkbox>
            </v-col>
        </v-row>
        <v-data-table :headers="headers"
                      :items="einsaetzeOhneAttest"
                      :mobile-breakpoint="1"
                      :search="search"> <!--@current-items="getFiltered"-->
            <template v-slot:item.spielTermin="{ item }">
                <div class="text-no-wrap">{{item.spielTermin}}</div>
            </template>
            <template v-slot:item.attest="{ item }">
                <div class="text-no-wrap">{{getAttestTargetDate(item.attest, item.dates, item.saison)}}</div>
            </template>
            <template v-slot:item.spielId="{ item }">
                <v-btn icon @click="openSpielbericht(item.spielId)">
                    <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn v-if="hasPermission"
                        icon @click="requestDeleteConfirm(item)">
                    <v-icon v-if="!item.deleted">mdi-delete</v-icon>
                    <v-icon v-else>mdi-delete-restore</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <spiel-bericht-edit-confirm v-if="$route.query.action==='displayErgebnisAttest'"
                                    :set-realtime="true"
                                    :currentData="selectedSpiel"
                                    action="displayErgebnisAttest">
        </spiel-bericht-edit-confirm>
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header"
                        :question="confirmDelete.question"
                        @reply="processConfirm" query-parameter="confirmAttestDelete">
        </confirm-dialog>
    </div>
</template>

<script>
    import FirebaseRead from "@/services/database/firebaseRead";
    import AttestTargetDateService from "@/services/data/attestTargetDate";
    import FirebaseWrite from "@/services/database/firebaseWrite";
    import SpielService from "@/services/data/spielService";
    import SpielBerichtEditConfirm from "../spielbericht/edit/spielBerichtEditConfirm";
    import ConfirmDialog from "../../../components/navigation/confirmDialog";
    export default {
        components: {
            ConfirmDialog,
            SpielBerichtEditConfirm},
        name: "einsatz-ohne-attest",
        props: ['lvId'],
        data: () => ({
            showDeleted: false,
            selectedSpiel: null,
            einsaetzeOhneAttestRaw: [],
            search: null,
            headers: [
                { text: 'Spiel', value: 'spielId' },
                { text: 'Spieltermin', value: 'spielTermin' },
                { text: 'Attest gültig bis', value: 'attest' },
                { text: 'AK', value: 'altersklasse' },
                { text: 'Spieler', value: 'spielerName' },
                { text: 'Verein', value: 'verein' },
                 { text: 'Liga', value: 'ligaName' },
                { text: 'Runde', value: 'ligaRunde' },
                { text: 'Status', value: 'status' },
                { text: '', value: 'actions' },
            ],
            confirmDelete: {
                open: false,
                question: '',
                item: null,
            },
            itemForDeletion: null,
        }),
        computed: {
            user(){ return this.$store.state.user; },
            hasPermission(){
                const role = 'sportobmann_' + this.lvId;
                return this.user.permissions[role];
            },
            landesverband(){
                return this.$store.state.realtime.landesverbaende[this.lvId];
            },
            einsaetzeOhneAttestUnfiltered(){
                return this.einsaetzeOhneAttestRaw.map(einsatzOhneAttest => {
                    einsatzOhneAttest.spielTermin = einsatzOhneAttest.infos.datum;
                    einsatzOhneAttest.ligaName = this.getLigaName(einsatzOhneAttest.saison.id);
                    einsatzOhneAttest.ligaRunde = einsatzOhneAttest.saison.runde + ' ' +
                                                  einsatzOhneAttest.saison.semester;
                    einsatzOhneAttest.altersklasse = SpielService.getAltersklasse(
                                                        einsatzOhneAttest.dates.akHJ,
                                                        einsatzOhneAttest.dates.akJahr,
                                                        einsatzOhneAttest.saison.id);
                    einsatzOhneAttest.status = einsatzOhneAttest.deleted ? 'gelöscht' : 'offen';
                    einsatzOhneAttest.deleted = einsatzOhneAttest.deleted ? true : false;
                    return einsatzOhneAttest;
                });
            },
            einsaetzeOhneAttest(){
                return this.showDeleted ? this.einsaetzeOhneAttestUnfiltered :
                    this.einsaetzeOhneAttestUnfiltered.filter(item => !item.deleted);
            }
        },
        created(){
            this.loadEinsaetzeOhneAttest();
        },
        methods: {
            async loadEinsaetzeOhneAttest(){
                const einsaetzeOhneAttestRawTEMP = await FirebaseRead.readDocList(
                    'attestFehlt', {
                        field: 'saison.lvId',
                        operator: '==',
                        value: this.lvId,
                    }
                );
                einsaetzeOhneAttestRawTEMP.forEach( (item) => {
                    if ( item.deleted === undefined ) {
                        item.deleted = false;
                    }
                });
                this.einsaetzeOhneAttestRaw = einsaetzeOhneAttestRawTEMP
            },
            getLigaName(ligaIdInklSportJahr){
                const ligaId = ligaIdInklSportJahr.substr(0, ligaIdInklSportJahr.length - 10);
                return this.landesverband.ligen[ligaId].name;
                //
            },
            async openSpielbericht(spielId){
                this.selectedSpiel = await FirebaseRead.readSingleDoc('spiele', spielId);
                console.log ("selectedSpiel", this.selectedSpiel);
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'displayErgebnisAttest';
                q.spielId = spielId;
                this.$router.push({path: p, query: q});
            },
            requestDeleteConfirm(item){
                this.itemForDeletion = item;
                if ( !item.deleted ) {
                    this.confirmDelete.header = 'Eintrag löschen';
                    this.confirmDelete.question = "Möchtest du den Eintrag für '" + item.spielerName +
                        "' auf Status 'gelöscht' setzen?";
                } else {
                    this.confirmDelete.header = 'Löschen zurücksetzen';
                    this.confirmDelete.question = "Möchtest du den Lösch-Status für '" + item.spielerName +
                        "' zurücksetzen?";
                }

                this.confirmDelete.open = true;
            },
            processConfirm(reply) {
                if ( reply ) {
                    this.processDeletion();
                }
                this.confirmDelete.open = false;
            },
            async processDeletion(){
                console.log ("DELTET", this.itemForDeletion);
                const reply = await FirebaseWrite.update('attestFehlt',
                   this.itemForDeletion.spielId + '_' + this.itemForDeletion.spielerId,
                    {deleted: !this.itemForDeletion.deleted}
                );
                if ( reply.successful ) {
                    this.einsaetzeOhneAttestRaw.find(item => item.id === this.itemForDeletion.id).deleted =
                        !this.itemForDeletion.deleted
                }
            },
            getAttestTargetDate(spielTag, dates, saison){
                return AttestTargetDateService.getTargetDates(spielTag, dates, saison)
            }
        },
    }
</script>

<style scoped>

</style>